<app-ui-main-menu>
    <mat-card>
       <mat-card-header style="
                display: flex;
                justify-content: space-between;
                padding: 10px 0 10px 0;
                align-items: center;
            "
        >
         <mat-card-title style="margin-bottom: 0;">Oportunidades</mat-card-title>
         <div align="end">
                <button
                    mat-button
                    class="btn-primary"
                    (click)="createCase()"
                >
                    Adicionar nova oportunidade
                </button>
            </div>
       </mat-card-header>
    
        <mat-divider></mat-divider>

        <br />
        <br />
        <mat-card-content>
            <mat-tab-group (selectedTabChange)="selectedTab($event)">
                <mat-tab label="Disponíveis" [ariaLabel]="'AVAILABLE'">
                    <ng-template matTabContent>
                        <app-available-cases-admin 
                            [loading]="loading"
                            [data]="casesDisponiveis"
                            [total]="total"
                            [pageLength]="pageLength"
                            (edit)="editCase($event)"
                            (pageChange)="pageChange($event)"
                            (inactivateCase)="inactiveCaseEvent($event)"
                        >
                        </app-available-cases-admin>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
    </mat-card>
</app-ui-main-menu>